module.exports = "../img/Lupa.svg";


//////////////////
// WEBPACK FOOTER
// ./Statics/img/Lupa.svg
// module id = 36
// module chunks = 0